module.exports = __webpack_public_path__ + "img/HPS015CP.22f66e46.png";